import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch } from 'react-redux';
import { useMutation } from 'react-query';


export const useDeleteScheduleRun = () => {
  const dispatch = useDispatch();

  const {
    isLoading, isError, isSuccess, mutate, reset,
  } = useMutation(
    async ({ orgId, crId, scheduleId }) => axiosInstance
      .delete(flow(orgId).deleteScheduledRun(crId, scheduleId)),
    {
      onSuccess: () => dispatch(showAlert({ message: 'Schedule has been deleted.', type: 'success' })),
      onError: (err) => dispatch(showAlert({ message: err.response.data.message, type: 'error' })),
    },
  );

  return {
    isLoading,
    isError,
    isSuccess,
    mutate,
    reset,
  };
};
